import React, { createContext, useState, useEffect } from "react";

const StripeContext = createContext();

export const StripeProvider = ({ children }) => {
  // const [stripeOnboardingState, setStripeOnboardingState] = useState(null);
  const [stripeAccountId, setStripeAccountId] = useState(null);

  // Load saved state from localStorage on initial render
  useEffect(() => {
    // const savedState = localStorage.getItem("stripeOnboardingState");
    const savedAccountId = localStorage.getItem("stripeAccountId");

    // if (savedState) {
    //   try {
    //     setStripeOnboardingState(savedState);
    //   } catch (e) {
    //     console.error("Error parsing saved Stripe state:", e);
    //   }
    // }

    if (savedAccountId) {
      setStripeAccountId(savedAccountId);
    }
  }, []);

  // // Save state to localStorage whenever it changes
  // useEffect(() => {
  //   if (stripeOnboardingState) {
  //     localStorage.setItem("stripeOnboardingState", stripeOnboardingState);
  //   }
  // }, [stripeOnboardingState]);

  // Save account ID to localStorage whenever it changes
  useEffect(() => {
    if (stripeAccountId) {
      localStorage.setItem("stripeAccountId", stripeAccountId);
    }
  }, [stripeAccountId]);

  return (
    <StripeContext.Provider
      value={{
        // stripeOnboardingState,
        // setStripeOnboardingState,
        stripeAccountId,
        setStripeAccountId,
      }}
    >
      {children}
    </StripeContext.Provider>
  );
};

export default StripeContext;
